/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Delete_BusyInputs */

const en_us2_profile_editors_delete_busy = /** @type {(inputs: Profile_Editors_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting…`)
};

const pt_br2_profile_editors_delete_busy = /** @type {(inputs: Profile_Editors_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluindo…`)
};

const es_419_profile_editors_delete_busy = /** @type {(inputs: Profile_Editors_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando…`)
};

const pt_pt2_profile_editors_delete_busy = /** @type {(inputs: Profile_Editors_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A eliminar…`)
};

const fr_fr2_profile_editors_delete_busy = /** @type {(inputs: Profile_Editors_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression…`)
};

const de_de2_profile_editors_delete_busy = /** @type {(inputs: Profile_Editors_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gelöscht…`)
};

const it_it2_profile_editors_delete_busy = /** @type {(inputs: Profile_Editors_Delete_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminazione…`)
};

/**
* | output |
* | --- |
* | "Deleting…" |
*
* @param {Profile_Editors_Delete_BusyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_delete_busy = /** @type {((inputs?: Profile_Editors_Delete_BusyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Delete_BusyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_delete_busy(inputs)
	if (locale === "es-419") return es_419_profile_editors_delete_busy(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_delete_busy(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_delete_busy(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_delete_busy(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_delete_busy(inputs)
	return en_us2_profile_editors_delete_busy(inputs)
});
export { profile_editors_delete_busy as "profile-editors.delete_busy" }